import type { MockRanking } from './types';

export const mockRankings: MockRanking[] = [
    {
        id: 'rank-1',
        title: '100 SL Donne Seniores - Lazio',
        scope: 'regionale',
        distance: 100,
        style: 'SL',
        pool: '50',
        year: 2026,
        category: 'S',
        entries: [
            { rank: 1, name: 'Alessandra Bruno', team: 'Polisportiva Tiburtina', time: '55.82', finaPoints: 852 },
            { rank: 2, name: 'Martina Greco', team: 'Aurelia Nuoto', time: '56.14', finaPoints: 842 },
            {
                rank: 3,
                athleteId: 'athlete-self',
                name: 'Giulia Bianchi',
                team: 'Heaven Due Nuoto',
                time: '56.48',
                finaPoints: 831
            },
            { rank: 4, name: 'Sofia Rizzo', team: 'GAM Team', time: '56.75', finaPoints: 823 },
            { rank: 5, name: 'Chiara Marino', team: 'CC Aniene', time: '57.02', finaPoints: 815 },
            { rank: 6, name: 'Federica Conti', team: 'SS Lazio Nuoto', time: '57.33', finaPoints: 806 },
            { rank: 7, name: 'Ilaria Romano', team: 'Polisportiva Tiburtina', time: '57.58', finaPoints: 799 },
            { rank: 8, name: 'Giorgia Esposito', team: 'Aurelia Nuoto', time: '57.81', finaPoints: 792 }
        ]
    },
    {
        id: 'rank-2',
        title: '200 SL Uomini Juniores - Nazionale',
        scope: 'nazionale',
        distance: 200,
        style: 'SL',
        pool: '50',
        year: 2026,
        category: 'J',
        entries: Array.from({ length: 20 }, (_, i) => ({
            rank: i + 1,
            name: `${['Marco', 'Luca', 'Alessandro', 'Matteo'][i % 4]} ${['Rossi', 'Bianchi', 'Ferrari', 'Conti'][i % 4]}`,
            team: ['CC Aniene', 'GAM Team', 'Dinamica Sport', 'NC Milano'][i % 4],
            time: `1:4${8 + Math.floor(i / 4)}.${String((i * 17) % 100).padStart(2, '0')}`,
            finaPoints: 865 - i * 8
        }))
    },
    {
        id: 'rank-3',
        title: '100 DO Donne Cadette - Regionale Lazio',
        scope: 'regionale',
        distance: 100,
        style: 'DO',
        pool: '50',
        year: 2026,
        category: 'C',
        entries: Array.from({ length: 12 }, (_, i) => ({
            rank: i + 1,
            athleteId: i === 4 ? 'athlete-self' : undefined,
            name:
                i === 4
                    ? 'Giulia Bianchi'
                    : `${['Sara', 'Alice', 'Valentina'][i % 3]} ${['Lombardi', 'Gallo', 'Fontana'][i % 3]}`,
            team: i === 4 ? 'Heaven Due Nuoto' : ['Polisportiva Tiburtina', 'Aurelia Nuoto', 'GAM Team'][i % 3],
            time: `1:0${8 + Math.floor(i / 3)}.${String((i * 23) % 100).padStart(2, '0')}`,
            finaPoints: 780 - i * 12
        }))
    }
];
